@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_444_684_304)
public val Res.string.employee_add_to_team: StringResource by lazy {
      StringResource("string:employee_add_to_team", "employee_add_to_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115022, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161234, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103641, 48),
      ))
    }

@delegate:ResourceContentHash(-53_687_117)
public val Res.string.employee_added_from_other_workplace: StringResource by lazy {
      StringResource("string:employee_added_from_other_workplace", "employee_added_from_other_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115075, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161307, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103690, 75),
      ))
    }

@delegate:ResourceContentHash(-327_724_902)
public val Res.string.employee_address: StringResource by lazy {
      StringResource("string:employee_address", "employee_address", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115163, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161403, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103766, 36),
      ))
    }

@delegate:ResourceContentHash(-101_260_830)
public val Res.string.employee_app_usage: StringResource by lazy {
      StringResource("string:employee_app_usage", "employee_app_usage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115196, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161444, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103803, 38),
      ))
    }

@delegate:ResourceContentHash(575_685_771)
public val Res.string.employee_bank_account: StringResource by lazy {
      StringResource("string:employee_bank_account", "employee_bank_account", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115255, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161535, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103842, 45),
      ))
    }

@delegate:ResourceContentHash(29_073_376)
public val Res.string.employee_basic_info: StringResource by lazy {
      StringResource("string:employee_basic_info", "employee_basic_info", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115313, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161633, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103888, 51),
      ))
    }

@delegate:ResourceContentHash(533_027_381)
public val Res.string.employee_below_minimum_hourly: StringResource by lazy {
      StringResource("string:employee_below_minimum_hourly", "employee_below_minimum_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115369, 193),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161709, 337),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103940, 177),
      ))
    }

@delegate:ResourceContentHash(478_471_830)
public val Res.string.employee_choose_person: StringResource by lazy {
      StringResource("string:employee_choose_person", "employee_choose_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115563, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 162047, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104118, 50),
      ))
    }

@delegate:ResourceContentHash(1_422_054_194)
public val Res.string.employee_contract_type: StringResource by lazy {
      StringResource("string:employee_contract_type", "employee_contract_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115614, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 162114, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104169, 50),
      ))
    }

@delegate:ResourceContentHash(529_717_370)
public val Res.string.employee_copy_link: StringResource by lazy {
      StringResource("string:employee_copy_link", "employee_copy_link", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115661, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 162177, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104220, 38),
      ))
    }

@delegate:ResourceContentHash(614_757_075)
public val Res.string.employee_counts_in_labour: StringResource by lazy {
      StringResource("string:employee_counts_in_labour", "employee_counts_in_labour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116125, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 162913, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104592, 73),
      ))
    }

@delegate:ResourceContentHash(1_219_659_756)
public val Res.string.employee_counts_in_labour_hint: StringResource by lazy {
      StringResource("string:employee_counts_in_labour_hint", "employee_counts_in_labour_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115704, 262),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 162256, 418),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104259, 218),
      ))
    }

@delegate:ResourceContentHash(1_304_455_941)
public val Res.string.employee_counts_in_labour_no_wage: StringResource by lazy {
      StringResource("string:employee_counts_in_labour_no_wage", "employee_counts_in_labour_no_wage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 115967, 157),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 162675, 237),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104478, 113),
      ))
    }

@delegate:ResourceContentHash(931_274_475)
public val Res.string.employee_create: StringResource by lazy {
      StringResource("string:employee_create", "employee_create", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116252, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163116, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104711, 43),
      ))
    }

@delegate:ResourceContentHash(1_964_444_938)
public val Res.string.employee_created: StringResource by lazy {
      StringResource("string:employee_created", "employee_created", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116203, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163043, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104666, 44),
      ))
    }

@delegate:ResourceContentHash(-2_144_966_725)
public val Res.string.employee_declared_hours: StringResource by lazy {
      StringResource("string:employee_declared_hours", "employee_declared_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116300, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163184, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104755, 51),
      ))
    }

@delegate:ResourceContentHash(414_913_314)
public val Res.string.employee_documents: StringResource by lazy {
      StringResource("string:employee_documents", "employee_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116472, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163460, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104911, 38),
      ))
    }

@delegate:ResourceContentHash(1_706_428_986)
public val Res.string.employee_documents_desc: StringResource by lazy {
      StringResource("string:employee_documents_desc", "employee_documents_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116360, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163268, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104807, 103),
      ))
    }

@delegate:ResourceContentHash(225_141_171)
public val Res.string.employee_edit_basic_info: StringResource by lazy {
      StringResource("string:employee_edit_basic_info", "employee_edit_basic_info", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116511, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163511, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104950, 64),
      ))
    }

@delegate:ResourceContentHash(306_119_458)
public val Res.string.employee_edit_financial_details: StringResource by lazy {
      StringResource("string:employee_edit_financial_details", "employee_edit_financial_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116584, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163620, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105015, 71),
      ))
    }

@delegate:ResourceContentHash(1_239_369_700)
public val Res.string.employee_edit_permissions: StringResource by lazy {
      StringResource("string:employee_edit_permissions", "employee_edit_permissions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116652, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163724, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105087, 57),
      ))
    }

@delegate:ResourceContentHash(-1_389_679_805)
public val Res.string.employee_edit_private_data: StringResource by lazy {
      StringResource("string:employee_edit_private_data", "employee_edit_private_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116710, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163802, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105145, 58),
      ))
    }

@delegate:ResourceContentHash(-35_731_881)
public val Res.string.employee_email_required: StringResource by lazy {
      StringResource("string:employee_email_required", "employee_email_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116773, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163901, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105204, 71),
      ))
    }

@delegate:ResourceContentHash(-214_335_429)
public val Res.string.employee_employer_cost: StringResource by lazy {
      StringResource("string:employee_employer_cost", "employee_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116837, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 163985, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105276, 50),
      ))
    }

@delegate:ResourceContentHash(-2_078_677_978)
public val Res.string.employee_financial_details: StringResource by lazy {
      StringResource("string:employee_financial_details", "employee_financial_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116892, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164068, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105327, 58),
      ))
    }

@delegate:ResourceContentHash(-1_838_870_101)
public val Res.string.employee_from_other_workplaces: StringResource by lazy {
      StringResource("string:employee_from_other_workplaces", "employee_from_other_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117123, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164415, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105570, 74),
      ))
    }

@delegate:ResourceContentHash(-1_504_314_199)
public val Res.string.employee_from_other_workplaces_hint: StringResource by lazy {
      StringResource("string:employee_from_other_workplaces_hint", "employee_from_other_workplaces_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 116947, 175),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164139, 275),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105386, 183),
      ))
    }

@delegate:ResourceContentHash(1_184_432_902)
public val Res.string.employee_fte: StringResource by lazy {
      StringResource("string:employee_fte", "employee_fte", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117229, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164553, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105676, 40),
      ))
    }

@delegate:ResourceContentHash(1_604_500_269)
public val Res.string.employee_fte_short: StringResource by lazy {
      StringResource("string:employee_fte_short", "employee_fte_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117194, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164510, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105645, 30),
      ))
    }

@delegate:ResourceContentHash(-1_128_394_039)
public val Res.string.employee_has_app_account: StringResource by lazy {
      StringResource("string:employee_has_app_account", "employee_has_app_account", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117294, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164642, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105717, 52),
      ))
    }

@delegate:ResourceContentHash(-1_747_422_007)
public val Res.string.employee_hidden_in_roster: StringResource by lazy {
      StringResource("string:employee_hidden_in_roster", "employee_hidden_in_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117638, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165186, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106045, 73),
      ))
    }

@delegate:ResourceContentHash(-1_340_289_165)
public val Res.string.employee_hidden_in_roster_hint: StringResource by lazy {
      StringResource("string:employee_hidden_in_roster_hint", "employee_hidden_in_roster_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117355, 282),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 164755, 430),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105770, 274),
      ))
    }

@delegate:ResourceContentHash(-1_521_987_626)
public val Res.string.employee_hourly: StringResource by lazy {
      StringResource("string:employee_hourly", "employee_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117708, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165292, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106119, 31),
      ))
    }

@delegate:ResourceContentHash(2_048_773_538)
public val Res.string.employee_invitation_options: StringResource by lazy {
      StringResource("string:employee_invitation_options", "employee_invitation_options", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117756, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165340, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106151, 59),
      ))
    }

@delegate:ResourceContentHash(-642_453_478)
public val Res.string.employee_invite_sent: StringResource by lazy {
      StringResource("string:employee_invite_sent", "employee_invite_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117808, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165428, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106211, 60),
      ))
    }

@delegate:ResourceContentHash(1_608_023_638)
public val Res.string.employee_is_primary: StringResource by lazy {
      StringResource("string:employee_is_primary", "employee_is_primary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117877, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165525, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106272, 43),
      ))
    }

@delegate:ResourceContentHash(-1_147_399_317)
public val Res.string.employee_minimum_top_up: StringResource by lazy {
      StringResource("string:employee_minimum_top_up", "employee_minimum_top_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 117925, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165593, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106316, 139),
      ))
    }

@delegate:ResourceContentHash(1_571_671_215)
public val Res.string.employee_model: StringResource by lazy {
      StringResource("string:employee_model", "employee_model", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118085, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165841, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106456, 30),
      ))
    }

@delegate:ResourceContentHash(1_356_513_817)
public val Res.string.employee_monthly: StringResource by lazy {
      StringResource("string:employee_monthly", "employee_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118136, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165896, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106487, 36),
      ))
    }

@delegate:ResourceContentHash(-1_160_214_302)
public val Res.string.employee_name_required: StringResource by lazy {
      StringResource("string:employee_name_required", "employee_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118185, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 165941, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106524, 70),
      ))
    }

@delegate:ResourceContentHash(-2_054_539_901)
public val Res.string.employee_no: StringResource by lazy {
      StringResource("string:employee_no", "employee_no", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118309, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166113, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106632, 23),
      ))
    }

@delegate:ResourceContentHash(808_205_624)
public val Res.string.employee_not_set: StringResource by lazy {
      StringResource("string:employee_not_set", "employee_not_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118264, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166060, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106595, 36),
      ))
    }

@delegate:ResourceContentHash(-314_157_452)
public val Res.string.employee_owner_partner_rate_hint: StringResource by lazy {
      StringResource("string:employee_owner_partner_rate_hint", "employee_owner_partner_rate_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118333, 180),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166141, 328),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106656, 188),
      ))
    }

@delegate:ResourceContentHash(1_553_726_961)
public val Res.string.employee_pay_next: StringResource by lazy {
      StringResource("string:employee_pay_next", "employee_pay_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118514, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166470, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106845, 45),
      ))
    }

@delegate:ResourceContentHash(-97_154_005)
public val Res.string.employee_pay_since: StringResource by lazy {
      StringResource("string:employee_pay_since", "employee_pay_since", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118560, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166516, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106891, 42),
      ))
    }

@delegate:ResourceContentHash(1_040_658_285)
public val Res.string.employee_payroll_id: StringResource by lazy {
      StringResource("string:employee_payroll_id", "employee_payroll_id", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118812, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166884, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107135, 83),
      ))
    }

@delegate:ResourceContentHash(-1_895_646_015)
public val Res.string.employee_payroll_id_help: StringResource by lazy {
      StringResource("string:employee_payroll_id_help", "employee_payroll_id_help", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118599, 212),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 166555, 328),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106934, 200),
      ))
    }

@delegate:ResourceContentHash(-2_145_729_765)
public val Res.string.employee_permission: StringResource by lazy {
      StringResource("string:employee_permission", "employee_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118962, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167106, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107289, 43),
      ))
    }

@delegate:ResourceContentHash(-1_999_755_472)
public val Res.string.employee_permissions_settings: StringResource by lazy {
      StringResource("string:employee_permissions_settings", "employee_permissions_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 118892, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167016, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107219, 69),
      ))
    }

@delegate:ResourceContentHash(-544_901_234)
public val Res.string.employee_phone: StringResource by lazy {
      StringResource("string:employee_phone", "employee_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119006, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167150, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107333, 30),
      ))
    }

@delegate:ResourceContentHash(-1_406_885_115)
public val Res.string.employee_picked_from_other: StringResource by lazy {
      StringResource("string:employee_picked_from_other", "employee_picked_from_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119041, 186),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167193, 242),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107364, 150),
      ))
    }

@delegate:ResourceContentHash(-246_032_803)
public val Res.string.employee_primary_workplace: StringResource by lazy {
      StringResource("string:employee_primary_workplace", "employee_primary_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119484, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167852, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107763, 58),
      ))
    }

@delegate:ResourceContentHash(158_429_675)
public val Res.string.employee_primary_workplace_hint: StringResource by lazy {
      StringResource("string:employee_primary_workplace_hint", "employee_primary_workplace_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119228, 255),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167436, 415),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107515, 247),
      ))
    }

@delegate:ResourceContentHash(-2_348_246)
public val Res.string.employee_private_data: StringResource by lazy {
      StringResource("string:employee_private_data", "employee_private_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119539, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167927, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107822, 45),
      ))
    }

@delegate:ResourceContentHash(177_358_875)
public val Res.string.employee_profile: StringResource by lazy {
      StringResource("string:employee_profile", "employee_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119589, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 167993, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107868, 48),
      ))
    }

@delegate:ResourceContentHash(1_271_350_293)
public val Res.string.employee_rate: StringResource by lazy {
      StringResource("string:employee_rate", "employee_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120020, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 168584, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108239, 29),
      ))
    }

@delegate:ResourceContentHash(-1_907_865_506)
public val Res.string.employee_rate_effective_from: StringResource by lazy {
      StringResource("string:employee_rate_effective_from", "employee_rate_effective_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119916, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 168472, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108143, 52),
      ))
    }

@delegate:ResourceContentHash(1_947_874_829)
public val Res.string.employee_rate_effective_from_hint: StringResource by lazy {
      StringResource("string:employee_rate_effective_from_hint", "employee_rate_effective_from_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119638, 277),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 168066, 405),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107917, 225),
      ))
    }

@delegate:ResourceContentHash(623_862_017)
public val Res.string.employee_rate_unit: StringResource by lazy {
      StringResource("string:employee_rate_unit", "employee_rate_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 119973, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 168521, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108196, 42),
      ))
    }

@delegate:ResourceContentHash(-1_230_012_928)
public val Res.string.employee_remove: StringResource by lazy {
      StringResource("string:employee_remove", "employee_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120295, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169019, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108558, 43),
      ))
    }

@delegate:ResourceContentHash(1_316_324_346)
public val Res.string.employee_remove_confirm: StringResource by lazy {
      StringResource("string:employee_remove_confirm", "employee_remove_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120050, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 168622, 319),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108269, 239),
      ))
    }

@delegate:ResourceContentHash(-1_940_451_067)
public val Res.string.employee_removed: StringResource by lazy {
      StringResource("string:employee_removed", "employee_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120242, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 168942, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108509, 48),
      ))
    }

@delegate:ResourceContentHash(-747_262_861)
public val Res.string.employee_salary: StringResource by lazy {
      StringResource("string:employee_salary", "employee_salary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120400, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169148, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108647, 31),
      ))
    }

@delegate:ResourceContentHash(-1_155_110_301)
public val Res.string.employee_salary_unit: StringResource by lazy {
      StringResource("string:employee_salary_unit", "employee_salary_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120343, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169095, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108602, 44),
      ))
    }

@delegate:ResourceContentHash(798_272_672)
public val Res.string.employee_send_invite_email: StringResource by lazy {
      StringResource("string:employee_send_invite_email", "employee_send_invite_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120444, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169188, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108679, 62),
      ))
    }

@delegate:ResourceContentHash(1_830_231_384)
public val Res.string.employee_send_invite_options: StringResource by lazy {
      StringResource("string:employee_send_invite_options", "employee_send_invite_options", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120519, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169295, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108742, 72),
      ))
    }

@delegate:ResourceContentHash(-1_479_370_054)
public val Res.string.employee_terms_history: StringResource by lazy {
      StringResource("string:employee_terms_history", "employee_terms_history", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120572, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169360, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108815, 62),
      ))
    }

@delegate:ResourceContentHash(586_300_590)
public val Res.string.employee_timeline: StringResource by lazy {
      StringResource("string:employee_timeline", "employee_timeline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120822, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169686, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109021, 37),
      ))
    }

@delegate:ResourceContentHash(1_204_743_112)
public val Res.string.employee_timeline_desc: StringResource by lazy {
      StringResource("string:employee_timeline_desc", "employee_timeline_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120651, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169455, 230),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108878, 142),
      ))
    }

@delegate:ResourceContentHash(-118_946_468)
public val Res.string.employee_total_employer_cost: StringResource by lazy {
      StringResource("string:employee_total_employer_cost", "employee_total_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120860, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169740, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109059, 64),
      ))
    }

@delegate:ResourceContentHash(-225_834_123)
public val Res.string.employee_updated: StringResource by lazy {
      StringResource("string:employee_updated", "employee_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120933, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169849, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109124, 48),
      ))
    }

@delegate:ResourceContentHash(-1_563_109_604)
public val Res.string.employee_works_unpaid: StringResource by lazy {
      StringResource("string:employee_works_unpaid", "employee_works_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121281, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 170393, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109420, 61),
      ))
    }

@delegate:ResourceContentHash(920_446_733)
public val Res.string.employee_works_unpaid_hint: StringResource by lazy {
      StringResource("string:employee_works_unpaid_hint", "employee_works_unpaid_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 120994, 286),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 169938, 454),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109173, 246),
      ))
    }

@delegate:ResourceContentHash(399_229_683)
public val Res.string.employee_yes: StringResource by lazy {
      StringResource("string:employee_yes", "employee_yes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121355, 24),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 170475, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109482, 24),
      ))
    }

@delegate:ResourceContentHash(2_099_863_373)
public val Res.string.error: StringResource by lazy {
      StringResource("string:error", "error", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125168, 21),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175924, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113127, 21),
      ))
    }

@delegate:ResourceContentHash(966_970_792)
public val Res.string.error_absence_reason_too_long: StringResource by lazy {
      StringResource("string:error_absence_reason_too_long", "error_absence_reason_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121409, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 170545, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109536, 93),
      ))
    }

@delegate:ResourceContentHash(-1_388_445_384)
public val Res.string.error_access_revoked: StringResource by lazy {
      StringResource("string:error_access_revoked", "error_access_revoked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121503, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 170699, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109630, 88),
      ))
    }

@delegate:ResourceContentHash(-1_565_318_799)
public val Res.string.error_availability_month_closed: StringResource by lazy {
      StringResource("string:error_availability_month_closed", "error_availability_month_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121584, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 170836, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109719, 151),
      ))
    }

@delegate:ResourceContentHash(1_568_073_559)
public val Res.string.error_availability_month_passed: StringResource by lazy {
      StringResource("string:error_availability_month_passed", "error_availability_month_passed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121744, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 171064, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109871, 115),
      ))
    }

@delegate:ResourceContentHash(-1_687_527_774)
public val Res.string.error_billing_not_allowed: StringResource by lazy {
      StringResource("string:error_billing_not_allowed", "error_billing_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121868, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 171228, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109987, 105),
      ))
    }

@delegate:ResourceContentHash(-1_143_462_301)
public val Res.string.error_billing_not_configured: StringResource by lazy {
      StringResource("string:error_billing_not_configured", "error_billing_not_configured", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121974, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 171430, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110093, 96),
      ))
    }

@delegate:ResourceContentHash(1_795_907_447)
public val Res.string.error_billing_offer_unavailable: StringResource by lazy {
      StringResource("string:error_billing_offer_unavailable", "error_billing_offer_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122063, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 171547, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110190, 115),
      ))
    }

@delegate:ResourceContentHash(-62_450_123)
public val Res.string.error_billing_pending: StringResource by lazy {
      StringResource("string:error_billing_pending", "error_billing_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122175, 149),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 171695, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110306, 137),
      ))
    }

@delegate:ResourceContentHash(1_644_218_849)
public val Res.string.error_billing_store: StringResource by lazy {
      StringResource("string:error_billing_store", "error_billing_store", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122325, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 171897, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110444, 111),
      ))
    }

@delegate:ResourceContentHash(378_894_175)
public val Res.string.error_business_name_required: StringResource by lazy {
      StringResource("string:error_business_name_required", "error_business_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122429, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172049, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110556, 68),
      ))
    }

@delegate:ResourceContentHash(1_999_655_331)
public val Res.string.error_email_in_use: StringResource by lazy {
      StringResource("string:error_email_in_use", "error_email_in_use", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122494, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172138, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110625, 82),
      ))
    }

@delegate:ResourceContentHash(716_723_903)
public val Res.string.error_generic: StringResource by lazy {
      StringResource("string:error_generic", "error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122642, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172382, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110773, 65),
      ))
    }

@delegate:ResourceContentHash(2_125_930_291)
public val Res.string.error_generic_detail: StringResource by lazy {
      StringResource("string:error_generic_detail", "error_generic_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122577, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172301, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110708, 64),
      ))
    }

@delegate:ResourceContentHash(985_726_899)
public val Res.string.error_invalid_credentials: StringResource by lazy {
      StringResource("string:error_invalid_credentials", "error_invalid_credentials", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122720, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172484, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110839, 65),
      ))
    }

@delegate:ResourceContentHash(1_368_151_940)
public val Res.string.error_invalid_email: StringResource by lazy {
      StringResource("string:error_invalid_email", "error_invalid_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122798, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172590, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110905, 67),
      ))
    }

@delegate:ResourceContentHash(1_408_163_051)
public val Res.string.error_no_pay_rates: StringResource by lazy {
      StringResource("string:error_no_pay_rates", "error_no_pay_rates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122866, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172706, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110973, 98),
      ))
    }

@delegate:ResourceContentHash(957_877_988)
public val Res.string.error_no_workplace_access: StringResource by lazy {
      StringResource("string:error_no_workplace_access", "error_no_workplace_access", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 122953, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172833, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111072, 89),
      ))
    }

@delegate:ResourceContentHash(-1_992_981_664)
public val Res.string.error_no_workplace_selected: StringResource by lazy {
      StringResource("string:error_no_workplace_selected", "error_no_workplace_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123031, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 172959, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111162, 71),
      ))
    }

@delegate:ResourceContentHash(1_396_808_601)
public val Res.string.error_not_a_one_off_cost: StringResource by lazy {
      StringResource("string:error_not_a_one_off_cost", "error_not_a_one_off_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123099, 172),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173055, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111234, 132),
      ))
    }

@delegate:ResourceContentHash(-1_757_221_300)
public val Res.string.error_not_found: StringResource by lazy {
      StringResource("string:error_not_found", "error_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123272, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173272, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111367, 59),
      ))
    }

@delegate:ResourceContentHash(2_089_210_727)
public val Res.string.error_offline: StringResource by lazy {
      StringResource("string:error_offline", "error_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123336, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173372, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111427, 85),
      ))
    }

@delegate:ResourceContentHash(1_141_786_329)
public val Res.string.error_one_off_amount: StringResource by lazy {
      StringResource("string:error_one_off_amount", "error_one_off_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123434, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173522, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111513, 64),
      ))
    }

@delegate:ResourceContentHash(22_385_357)
public val Res.string.error_one_off_date: StringResource by lazy {
      StringResource("string:error_one_off_date", "error_one_off_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123503, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173615, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111578, 58),
      ))
    }

@delegate:ResourceContentHash(250_942_708)
public val Res.string.error_one_off_period: StringResource by lazy {
      StringResource("string:error_one_off_period", "error_one_off_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123570, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173702, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111637, 80),
      ))
    }

@delegate:ResourceContentHash(-1_198_939_364)
public val Res.string.error_permission_denied: StringResource by lazy {
      StringResource("string:error_permission_denied", "error_permission_denied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123671, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 173851, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111718, 139),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString14Resources(map: MutableMap<String, StringResource>) {
  map.put("employee_add_to_team", Res.string.employee_add_to_team)
  map.put("employee_added_from_other_workplace", Res.string.employee_added_from_other_workplace)
  map.put("employee_address", Res.string.employee_address)
  map.put("employee_app_usage", Res.string.employee_app_usage)
  map.put("employee_bank_account", Res.string.employee_bank_account)
  map.put("employee_basic_info", Res.string.employee_basic_info)
  map.put("employee_below_minimum_hourly", Res.string.employee_below_minimum_hourly)
  map.put("employee_choose_person", Res.string.employee_choose_person)
  map.put("employee_contract_type", Res.string.employee_contract_type)
  map.put("employee_copy_link", Res.string.employee_copy_link)
  map.put("employee_counts_in_labour", Res.string.employee_counts_in_labour)
  map.put("employee_counts_in_labour_hint", Res.string.employee_counts_in_labour_hint)
  map.put("employee_counts_in_labour_no_wage", Res.string.employee_counts_in_labour_no_wage)
  map.put("employee_create", Res.string.employee_create)
  map.put("employee_created", Res.string.employee_created)
  map.put("employee_declared_hours", Res.string.employee_declared_hours)
  map.put("employee_documents", Res.string.employee_documents)
  map.put("employee_documents_desc", Res.string.employee_documents_desc)
  map.put("employee_edit_basic_info", Res.string.employee_edit_basic_info)
  map.put("employee_edit_financial_details", Res.string.employee_edit_financial_details)
  map.put("employee_edit_permissions", Res.string.employee_edit_permissions)
  map.put("employee_edit_private_data", Res.string.employee_edit_private_data)
  map.put("employee_email_required", Res.string.employee_email_required)
  map.put("employee_employer_cost", Res.string.employee_employer_cost)
  map.put("employee_financial_details", Res.string.employee_financial_details)
  map.put("employee_from_other_workplaces", Res.string.employee_from_other_workplaces)
  map.put("employee_from_other_workplaces_hint", Res.string.employee_from_other_workplaces_hint)
  map.put("employee_fte", Res.string.employee_fte)
  map.put("employee_fte_short", Res.string.employee_fte_short)
  map.put("employee_has_app_account", Res.string.employee_has_app_account)
  map.put("employee_hidden_in_roster", Res.string.employee_hidden_in_roster)
  map.put("employee_hidden_in_roster_hint", Res.string.employee_hidden_in_roster_hint)
  map.put("employee_hourly", Res.string.employee_hourly)
  map.put("employee_invitation_options", Res.string.employee_invitation_options)
  map.put("employee_invite_sent", Res.string.employee_invite_sent)
  map.put("employee_is_primary", Res.string.employee_is_primary)
  map.put("employee_minimum_top_up", Res.string.employee_minimum_top_up)
  map.put("employee_model", Res.string.employee_model)
  map.put("employee_monthly", Res.string.employee_monthly)
  map.put("employee_name_required", Res.string.employee_name_required)
  map.put("employee_no", Res.string.employee_no)
  map.put("employee_not_set", Res.string.employee_not_set)
  map.put("employee_owner_partner_rate_hint", Res.string.employee_owner_partner_rate_hint)
  map.put("employee_pay_next", Res.string.employee_pay_next)
  map.put("employee_pay_since", Res.string.employee_pay_since)
  map.put("employee_payroll_id", Res.string.employee_payroll_id)
  map.put("employee_payroll_id_help", Res.string.employee_payroll_id_help)
  map.put("employee_permission", Res.string.employee_permission)
  map.put("employee_permissions_settings", Res.string.employee_permissions_settings)
  map.put("employee_phone", Res.string.employee_phone)
  map.put("employee_picked_from_other", Res.string.employee_picked_from_other)
  map.put("employee_primary_workplace", Res.string.employee_primary_workplace)
  map.put("employee_primary_workplace_hint", Res.string.employee_primary_workplace_hint)
  map.put("employee_private_data", Res.string.employee_private_data)
  map.put("employee_profile", Res.string.employee_profile)
  map.put("employee_rate", Res.string.employee_rate)
  map.put("employee_rate_effective_from", Res.string.employee_rate_effective_from)
  map.put("employee_rate_effective_from_hint", Res.string.employee_rate_effective_from_hint)
  map.put("employee_rate_unit", Res.string.employee_rate_unit)
  map.put("employee_remove", Res.string.employee_remove)
  map.put("employee_remove_confirm", Res.string.employee_remove_confirm)
  map.put("employee_removed", Res.string.employee_removed)
  map.put("employee_salary", Res.string.employee_salary)
  map.put("employee_salary_unit", Res.string.employee_salary_unit)
  map.put("employee_send_invite_email", Res.string.employee_send_invite_email)
  map.put("employee_send_invite_options", Res.string.employee_send_invite_options)
  map.put("employee_terms_history", Res.string.employee_terms_history)
  map.put("employee_timeline", Res.string.employee_timeline)
  map.put("employee_timeline_desc", Res.string.employee_timeline_desc)
  map.put("employee_total_employer_cost", Res.string.employee_total_employer_cost)
  map.put("employee_updated", Res.string.employee_updated)
  map.put("employee_works_unpaid", Res.string.employee_works_unpaid)
  map.put("employee_works_unpaid_hint", Res.string.employee_works_unpaid_hint)
  map.put("employee_yes", Res.string.employee_yes)
  map.put("error", Res.string.error)
  map.put("error_absence_reason_too_long", Res.string.error_absence_reason_too_long)
  map.put("error_access_revoked", Res.string.error_access_revoked)
  map.put("error_availability_month_closed", Res.string.error_availability_month_closed)
  map.put("error_availability_month_passed", Res.string.error_availability_month_passed)
  map.put("error_billing_not_allowed", Res.string.error_billing_not_allowed)
  map.put("error_billing_not_configured", Res.string.error_billing_not_configured)
  map.put("error_billing_offer_unavailable", Res.string.error_billing_offer_unavailable)
  map.put("error_billing_pending", Res.string.error_billing_pending)
  map.put("error_billing_store", Res.string.error_billing_store)
  map.put("error_business_name_required", Res.string.error_business_name_required)
  map.put("error_email_in_use", Res.string.error_email_in_use)
  map.put("error_generic", Res.string.error_generic)
  map.put("error_generic_detail", Res.string.error_generic_detail)
  map.put("error_invalid_credentials", Res.string.error_invalid_credentials)
  map.put("error_invalid_email", Res.string.error_invalid_email)
  map.put("error_no_pay_rates", Res.string.error_no_pay_rates)
  map.put("error_no_workplace_access", Res.string.error_no_workplace_access)
  map.put("error_no_workplace_selected", Res.string.error_no_workplace_selected)
  map.put("error_not_a_one_off_cost", Res.string.error_not_a_one_off_cost)
  map.put("error_not_found", Res.string.error_not_found)
  map.put("error_offline", Res.string.error_offline)
  map.put("error_one_off_amount", Res.string.error_one_off_amount)
  map.put("error_one_off_date", Res.string.error_one_off_date)
  map.put("error_one_off_period", Res.string.error_one_off_period)
  map.put("error_permission_denied", Res.string.error_permission_denied)
}
